import { Observable } from 'rxjs'

import { request, parseAPIError, DownloadRequest } from '../../common/api'

import * as actionTypes from './actionTypes'
import * as actionCreators from './actionCreators'
import * as tableModelActionTypes from '../../common/table/actionTypes'
import { resolveModelState } from '../../common/table/helpers'

// Fetch

const fetchReportTrailerFuelingsEpic = (action$, store) => {
    const tableIdentifier = 'report_trailer_fuelings'

    return action$
        .ofType(actionTypes.FETCH, tableModelActionTypes.CONFIGURATION_CHANGED)
        .filter(action => action.type !== tableModelActionTypes.CONFIGURATION_CHANGED || action.payload.tableIdentifier === tableIdentifier)
        .switchMap(action => {
            const modelState = resolveModelState(tableIdentifier, store.getState(), action)

            return Observable.concat(
                Observable.of({
                    type: actionTypes.FETCH_STARTED,
                }),
                request({
                    method: 'POST',
                    path: `report-trailer-fuelings`,
                    body: {
                        filters: modelState.get('filters').toJS(),
                    },
                })
                    .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportTrailerFuelingsFulfilled(ajaxResponse.response)))
                    .catch(error => Observable.of(actionCreators.fetchReportTrailerFuelingsRejected(parseAPIError(error))))
                    .takeUntil(action$.ofType(actionTypes.FETCH_CANCELLED, actionTypes.FETCH))
            )
        })
}

// Export

const exportReportTrailerFuelingsEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT).switchMap(action => {
        const filters = JSON.stringify(action.payload)
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-trailer-fuelings/export?filters=${filters}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_FULFILLED,
            })
        )
    })

// Fetch details

const fetchReportTrailerFuelingDetailsEpic = (action$, store) =>
    action$.ofType(actionTypes.FETCH_DETAILS).switchMap(action => {
        const tableIdentifier = 'report_trailer_fuelings'
        const modelState = resolveModelState(tableIdentifier, store.getState(), action)

        return Observable.concat(
            Observable.of({
                type: actionTypes.FETCH_DETAILS_STARTED,
            }),
            request({
                method: 'POST',
                path: `report-trailer-fuelings/details`,
                body: {
                    trailer_id: action.payload.trailerId,
                    date_from: action.payload.dateFrom,
                    date_to: action.payload.dateTo,
                    filters: modelState.get('filters').toJS(),
                },
            })
                .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportTrailerFuelingDetailsFulfilled(ajaxResponse.response)))
                .catch(error => Observable.of(actionCreators.fetchReportTrailerFuelingDetailsRejected(parseAPIError(error))))
                .takeUntil(action$.ofType(actionTypes.FETCH_DETAILS_CANCELLED))
        )
    })

// Export details

const exportReportTrailerFuelingDetailsEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT_DETAILS).switchMap(action => {
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-trailer-fuelings/details/export?trailer_id=${action.payload.trailerId}&date_from=${action.payload.dateFrom}&date_to=${action.payload.dateTo}&filters=${JSON.stringify({ ...action.payload.filters })}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_DETAILS_FULFILLED,
            })
        )
    })

export default [
    fetchReportTrailerFuelingsEpic,
    exportReportTrailerFuelingsEpic,
    fetchReportTrailerFuelingDetailsEpic,
    exportReportTrailerFuelingDetailsEpic,
]
